declare global {
	interface Window {
		rdt: (option: string, trackingType: string) => void
	}
}

export function redditTrack(type: string, opts?: Record<string, any>) {
	if (!window.rdt) {
		console.warn(
			'window.rdt is not defined. This could mean your reddit pixel script has not loaded on the page yet.',
		)
		return
	}
	window.rdt('track', type)
}
